// Generated by prepyo-voicegen (voicegen.py learn). Do not edit by hand.
// Each spoken text of the Learn Korean course, mapped to its stored audio in
// question_assets, served at /api/v1/questions/assets/<id>.
export const LEARN_AUDIO: Record<string, string> = {
  "아": "tts_ko_b0265bbd5d4a98f9d14a",
  "어": "tts_ko_c323bb5edabf58b6d6bd",
  "오": "tts_ko_536432bd1a559a2e79c0",
  "우": "tts_ko_21c6c92abf54011cece3",
  "으": "tts_ko_c403a917ce47115f6045",
  "이": "tts_ko_49ecda20a51aba4d06e5",
  "가": "tts_ko_1daf504961307ae73710",
  "나": "tts_ko_8e26acfd257feb01a0ac",
  "다": "tts_ko_004a9f8d4e7853a656dc",
  "라": "tts_ko_f7a24c2e7070932e97ee",
  "마": "tts_ko_77f39661ba2d70849654",
  "바": "tts_ko_6032f1b116d11cc99613",
  "사": "tts_ko_ef1c2e9105933c0fde2a",
  "자": "tts_ko_5c627e9828ce67b6e41a",
  "하": "tts_ko_a3745379edbd436ec40b",
  "노": "tts_ko_9a9045c74afeadcd671f",
  "밥": "tts_ko_c5c125e8c89da9182387",
  "우유": "tts_ko_356925541a8dd7987995",
  "아이": "tts_ko_191e8b638930cb48e406",
  "나무": "tts_ko_5b16e86c5682cf55a997",
  "모자": "tts_ko_972f84b5378dfa52d293",
  "바다": "tts_ko_abbd30fa34e3f7e2dc13",
  "물": "tts_ko_9cc3e1c10214ed472abe",
  "집": "tts_ko_284f1d42ace0a3684ee6",
  "네": "tts_ko_0e17e7a55847b910e6b9",
  "아니요": "tts_ko_76f3bc8811f5f0bb9be0",
  "감사합니다": "tts_ko_4e26e61d12ebbf884f17",
  "안녕하세요": "tts_ko_f91fb0ad896e04918c60",
  "안녕히 가세요": "tts_ko_1481b81306f8a28b1783",
  "죄송합니다": "tts_ko_6ff2f07e70e960af907b",
  "괜찮아요": "tts_ko_b772fd9ea1c1b5d9dfcd",
  "반갑습니다": "tts_ko_7a9e9ede1d627f30379d",
  "저": "tts_ko_495d297a453e2988df02",
  "사람": "tts_ko_0d1f8f8126d1b75e4785",
  "친구": "tts_ko_d516c2a090b9579e57e2",
  "사장님": "tts_ko_4b0fa1faaabc7cd10b16",
  "동료": "tts_ko_1c4f687e894fb2cd0193",
  "가족": "tts_ko_f687abc1f4a09ce45e69",
  "이거": "tts_ko_e00453f9adb7d5844c0b",
  "여기": "tts_ko_3270cc6bccdfa3e2d80b",
  "지금": "tts_ko_11cf4e9702075af861dd",
  "있어요": "tts_ko_cc6e8c048a6a8eb13378",
  "없어요": "tts_ko_8e7ed755450978886f75",
  "좋아요": "tts_ko_1a4ee3f0574de0ecff1a",
  "가요": "tts_ko_23dea2e4e736bed06972",
  "와요": "tts_ko_0d3673aca93c1971d1d9",
  "먹어요": "tts_ko_19cb1871a460a7bb4456",
  "마셔요": "tts_ko_b8422a1940246f6e35f0",
  "일해요": "tts_ko_653cadd15a42f927c230",
  "자요": "tts_ko_b097e437533db959c850",
  "물을 마셔요": "tts_ko_fd20038b99790f785e57",
  "우유를 마셔요": "tts_ko_d3c97517dc1773bdb9f2",
  "회사에 가요": "tts_ko_f0f5084895fe0cca5420",
  "저는 네팔 사람이에요": "tts_ko_3a40b54af99eecd0f527",
  "집에 가요": "tts_ko_edccbc71ee83bf4d311a",
  "하나": "tts_ko_768198de18b0821687dd",
  "둘": "tts_ko_be82b3dc9a8530383c9f",
  "셋": "tts_ko_aac819b88fa1fb1fabf2",
  "넷": "tts_ko_253e756bce3f9853bcb3",
  "다섯": "tts_ko_feae273cdbd56bde2b15",
  "여섯": "tts_ko_1170c7507f5955ebbb5a",
  "일곱": "tts_ko_0f833bae546b43495ccd",
  "여덟": "tts_ko_b4297e2662ffff39d8d5",
  "아홉": "tts_ko_fbdd2c266f17e39fbead",
  "열": "tts_ko_6994d41f745ef023dc75",
  "아버지": "tts_ko_3dbed9058593a9eec591",
  "어머니": "tts_ko_6e3bfef7730fec6e65c0",
  "아내": "tts_ko_57b515cbc21946fa21cc",
  "남편": "tts_ko_c93afb144c542de2134e",
  "아들": "tts_ko_36b68fd37be62f905120",
  "딸": "tts_ko_ef6b4b2c3a7f3e8172f0",
  "형": "tts_ko_b78a4e99247caa6e4c99",
  "누나": "tts_ko_ad5fd26f53fcd9567a4d",
  "동생": "tts_ko_7c433b800e52cf378017",
  "할머니": "tts_ko_0e1fd6a79c93f7a71f58",
  "머리": "tts_ko_7110a0e67af740b6afe2",
  "눈": "tts_ko_868521e25c5f7eeccc09",
  "코": "tts_ko_515923a4cf6edc7ecde0",
  "입": "tts_ko_42395d09bd704009b3a0",
  "귀": "tts_ko_dfcc4234eeab34057824",
  "손": "tts_ko_d1b1b28f6e3877523456",
  "발": "tts_ko_e99f998f1353d28a4ecd",
  "다리": "tts_ko_6206ce15429897461e21",
  "팔": "tts_ko_44101f1c6e97488536ef",
  "허리": "tts_ko_0cc72c2063bff3f58cd6",
  "오늘": "tts_ko_3249b3098586bab00e92",
  "내일": "tts_ko_2c8065b8b639c917dd71",
  "어제": "tts_ko_71f1f049ebeaa3971b8a",
  "아침": "tts_ko_253e09dc5a6a0d313665",
  "점심": "tts_ko_c7f621d4304affcd44d6",
  "저녁": "tts_ko_394bc105fb433732cbea",
  "밤": "tts_ko_b8f613e551d7fc4e9529",
  "주말": "tts_ko_25bee968c824cb41c362",
  "매일": "tts_ko_f5ad5179fc5cb2566dec",
  "나중에": "tts_ko_0544f27d7319cd4d3a09",
  "월요일": "tts_ko_ea9c6c2be2d481205c69",
  "화요일": "tts_ko_a14a499ce16e2dd5435c",
  "수요일": "tts_ko_df73a8120c83e37c988d",
  "목요일": "tts_ko_b10dcb760114883e75f5",
  "금요일": "tts_ko_8498502820448dcb0a43",
  "토요일": "tts_ko_9afce518ab682ffec73a",
  "일요일": "tts_ko_d606e8e7e80964521311",
  "일월": "tts_ko_4eb7229e2349053f7018",
  "유월": "tts_ko_174662c16b4998f79f3d",
  "시월": "tts_ko_a78264797ca18eaae47d",
  "빨간색": "tts_ko_01412bda9cd257ffb6dd",
  "파란색": "tts_ko_bcd85360bcd467852a7f",
  "노란색": "tts_ko_a9f494fac09fb6e948ed",
  "초록색": "tts_ko_5a4dbd57aed6eedf1f6a",
  "검은색": "tts_ko_66cee63261bb97bdc85b",
  "흰색": "tts_ko_5136625cefa38471a8ef",
  "회색": "tts_ko_faff48cc08611aff94cf",
  "주황색": "tts_ko_1641bcf2e36aa03c939a",
  "보라색": "tts_ko_01678e10b9d7b4b5fdd3",
  "갈색": "tts_ko_5bb96e6032aed4c24761",
  "일어나요": "tts_ko_ce64f95726ee4a79bfd1",
  "앉아요": "tts_ko_a106a484efca301b15b8",
  "씻어요": "tts_ko_6f5f47af78c7107c32c0",
  "기다려요": "tts_ko_722732dca015573108ed",
  "도와줘요": "tts_ko_e4efd568059bdc065c67",
  "알아요": "tts_ko_4d471997b968b0c2d0d1",
  "몰라요": "tts_ko_c99a6874062f2eef173c",
  "배워요": "tts_ko_97b6f0ae24403d918801",
  "사요": "tts_ko_ca8de53e67a5fa94fb72",
  "줘요": "tts_ko_aa8ea8e9a59a875622f1",
  "커요": "tts_ko_efc50e722229dd512580",
  "작아요": "tts_ko_cb9afab246c2d8262ab6",
  "많아요": "tts_ko_d7dec01e6c55365e8f1b",
  "적어요": "tts_ko_3fe8ea807f123b3e8d74",
  "무거워요": "tts_ko_f581b2404914fa58537c",
  "가벼워요": "tts_ko_990663f35c16f42b14ab",
  "뜨거워요": "tts_ko_fbeed929895494df3095",
  "차가워요": "tts_ko_b08352f16cf5db7b03fa",
  "빨라요": "tts_ko_b88c0c397d7b89745f1a",
  "느려요": "tts_ko_cfbb3c8e8b5bdf34682b",
  "이름이 뭐예요?": "tts_ko_79ece9535b306d04dab4",
  "제 이름은 사가르예요": "tts_ko_3d1fc956753e856cba37",
  "이것은 망치예요": "tts_ko_ab07eb43a8be8509ae65",
  "저는 근로자예요": "tts_ko_e40c32cc7fa7024684ff",
  "시간이 있어요": "tts_ko_06cfd5ad37ce67866649",
  "돈이 없어요": "tts_ko_6b61c60a563e91efa499",
  "배가 아파요": "tts_ko_98fc63779de6e6d666fe",
  "기계가 고장 났어요": "tts_ko_d5daf427a73c6c05a890",
  "밥을 먹어요": "tts_ko_70722bf8a1b8dd7149b0",
  "상자를 옮겨요": "tts_ko_aaf4bcb1a982ee9ea350",
  "한국어를 배워요": "tts_ko_2034713dfc449300fb09",
  "문을 닫아요": "tts_ko_a3201b23d0c5502dc76b",
  "봐요": "tts_ko_4e2c1efa1a58b83cbe13",
  "공장에 가요": "tts_ko_c02c8c5546815e87dc65",
  "기숙사에 있어요": "tts_ko_2eadd8e2fcc661d15503",
  "공장에서 일해요": "tts_ko_870e335ca38a722b1d1a",
  "식당에서 밥을 먹어요": "tts_ko_5c119d0a94d9966ab21f",
  "사무실에 있어요": "tts_ko_77a1758bb4dc372de621",
  "안 가요": "tts_ko_67d2f9411bfae1a2e68b",
  "일 안 해요": "tts_ko_4be3ef7e3efe8f75cf50",
  "못 가요": "tts_ko_cdbded61f67e147cb7df",
  "오늘은 바쁘지 않아요": "tts_ko_4f882d63568799caafc4",
  "오늘은 일 안 해요": "tts_ko_5072a662901937775d2b",
  "앉으세요": "tts_ko_339be81d70b37be157e1",
  "장갑을 끼세요": "tts_ko_4b23373112e29133b344",
  "만지지 마세요": "tts_ko_537f0306bdf62ca0ec5c",
  "담배를 피우지 마세요": "tts_ko_aa5ad0a4e683712b68a0",
  "여기에서 사진을 찍지 마세요": "tts_ko_8340fc73ebac4092a616",
  "어제 일했어요": "tts_ko_16ef1100e321d2f03186",
  "밥을 먹었어요": "tts_ko_7b86c759bcbbb205ebc3",
  "시장에 갔어요": "tts_ko_3f44536864443146f1b3",
  "손을 다쳤어요": "tts_ko_7469d0fd3767d4a567c3",
  "어제 친구를 만났어요": "tts_ko_7df2109be426942f9ffd",
  "지금 일하고 있어요": "tts_ko_2f59f3a5482598f1a123",
  "상자를 옮기고 있어요": "tts_ko_b0306feb426fa31ab0c2",
  "내일 병원에 갈 거예요": "tts_ko_83314b27e0efa82e7eb7",
  "주말에 쉴 거예요": "tts_ko_97c04998fe39b9f0ef5a",
  "지금 뭐 하고 있어요?": "tts_ko_b829d2813db8529175ef",
  "일, 이, 삼, 사, 오": "tts_ko_2cb86baf763b5b1e90ec",
  "십, 백, 천, 만": "tts_ko_5c9fe9167e4b1dfbdf22",
  "천 원": "tts_ko_76233572d8d1ae978bc7",
  "세 시": "tts_ko_7b9c68fdd100be01163b",
  "삼십 분": "tts_ko_cc6558a94427a2ec4f88",
  "오천 원": "tts_ko_70012a6dc5b68845be6d",
  "회사": "tts_ko_eeb3acff416077407a0a",
  "공장": "tts_ko_77c4c226341e31662fe6",
  "사무실": "tts_ko_bd9c36448eb56ade27c8",
  "기숙사": "tts_ko_445e4fa12fbe9e5d1b3c",
  "월급": "tts_ko_6042577c563beb0bd6bf",
  "휴가": "tts_ko_ebc9cf9e892ea7fd6049",
  "망치": "tts_ko_ec91f321b198ddb99f02",
  "가위": "tts_ko_134c588cfa732149ec00",
  "칼": "tts_ko_4229a4f97cdcc642e629",
  "사다리": "tts_ko_7c68bcfec958bdba55e1",
  "장갑": "tts_ko_d5612b0268911e6a2858",
  "상자": "tts_ko_2c9e01bf65e36c3c9a6e",
  "기계": "tts_ko_fcb32d94508ac347766e",
  "전원": "tts_ko_f48931e32480ea120c81",
  "버튼": "tts_ko_d3d7e0de1cb54a24e4ff",
  "켜요": "tts_ko_23f6db566f3619385358",
  "꺼요": "tts_ko_d0dd996e5cb5eef4b24c",
  "고장 났어요": "tts_ko_75838e1183216822ac81",
  "전원을 켜요": "tts_ko_4b0686ac22118ee0193e",
  "안전": "tts_ko_0e5e8bae5914459c3b09",
  "위험": "tts_ko_c1a1abb65cf69670e02a",
  "조심하세요": "tts_ko_d8eabb82de51290d29e0",
  "금연": "tts_ko_bacbbeec47b09be07792",
  "출입 금지": "tts_ko_2ced38749dfc03d7c023",
  "안전모": "tts_ko_649a4faf3226bc6b6ac2",
  "소화기": "tts_ko_239e70925a6eaa882454",
  "드라이버": "tts_ko_ba35b6c0d731d27f8627",
  "렌치": "tts_ko_800dd18793b55584de4e",
  "펜치": "tts_ko_a6cfe38dd9b7f79f99b8",
  "테이프": "tts_ko_69c4f39c9d7d4ff268cd",
  "끈": "tts_ko_8bf6d14d5d4a0942460b",
  "접착제": "tts_ko_72c4469d4a4e58fa55cb",
  "손전등": "tts_ko_b7975808c75cdf38691a",
  "카트": "tts_ko_455044c32188e3b72cc8",
  "지게차": "tts_ko_c5928fc395dc53300b37",
  "공구함": "tts_ko_2f90101aba18c525e59f",
  "반장님": "tts_ko_9cc372e21328525d4be2",
  "과장님": "tts_ko_eae0b85b4416250221d2",
  "직원": "tts_ko_9b486b0db24b96a0e423",
  "근로자": "tts_ko_6f2a66f169f71200cda0",
  "외국인": "tts_ko_353e8f9eadcb441d370d",
  "통역": "tts_ko_522af2540b235596d47a",
  "관리자": "tts_ko_2a90777cccf7e022cba3",
  "신입": "tts_ko_8acefa59a22992b0e78e",
  "경비원": "tts_ko_d35a16ee1d294087a6c5",
  "운전기사": "tts_ko_84e9c2f49bd3f0d3067a",
  "계약서": "tts_ko_1fb503221518366c5a9a",
  "급여": "tts_ko_371a3f338c8603cc25e6",
  "시급": "tts_ko_bb4b0714547a0a3bc63c",
  "수당": "tts_ko_47a5046dadf4e2f8ace8",
  "보너스": "tts_ko_5fecc7384af28138b843",
  "세금": "tts_ko_7eae1608f7dcc92cfa97",
  "보험": "tts_ko_3f908ee6eb4c02494be5",
  "퇴직금": "tts_ko_9d8e279c48d7233815a5",
  "월급날": "tts_ko_196407af977d2d5cc25a",
  "사인": "tts_ko_11447631dcb0d2c8b97e",
  "출근": "tts_ko_4ac9841b0294ea3bb9fc",
  "퇴근": "tts_ko_7a89080fcd5f08e540b4",
  "야근": "tts_ko_049dda59fbaca794b462",
  "잔업": "tts_ko_720d090d4ce18e302aca",
  "근무 시간": "tts_ko_d7fb9c9b2ae07a97a6b1",
  "휴일": "tts_ko_26853e23f1cd36fe4168",
  "연차": "tts_ko_edafb91bcc55052476c4",
  "병가": "tts_ko_c301604135b9c7142d3d",
  "지각": "tts_ko_bed39a251324e3c77c3e",
  "결근": "tts_ko_df27756816f351c9522f",
  "생산": "tts_ko_80c948c0d08bc8274e48",
  "조립": "tts_ko_793e55e44638b6dfd06b",
  "검사": "tts_ko_0cb7bb939066fa1c89d6",
  "포장": "tts_ko_912ca71a75fa20527383",
  "운반": "tts_ko_840f44dfd892126e7c64",
  "불량": "tts_ko_da2e1526203d475e12dc",
  "제품": "tts_ko_9d0b438b1f0d246e3fe3",
  "부품": "tts_ko_c8b3ac586a40a1f96651",
  "라인": "tts_ko_4cfc70dd0a1e722332be",
  "재고": "tts_ko_11e14e4a5ac9471c25a1",
  "철": "tts_ko_e3ebfff07fb36798effe",
  "플라스틱": "tts_ko_fa0a661cb46822d29c19",
  "종이": "tts_ko_c98ea724bf877acbfa65",
  "유리": "tts_ko_96daa8898c970e607293",
  "고무": "tts_ko_b7c5608638854ae8bb87",
  "옷감": "tts_ko_f17d889696858df2f9c1",
  "기름": "tts_ko_9bf2f3e6a88e365cf88b",
  "페인트": "tts_ko_858b65bf76b789f0a6d3",
  "전선": "tts_ko_8201e39d621be25d3942",
  "옮겨요": "tts_ko_e7a6cd747c1557ffd127",
  "들어요": "tts_ko_a822eb536e63714a2931",
  "놓아요": "tts_ko_c851c443371f6ba420d3",
  "잘라요": "tts_ko_13cb719d030783767986",
  "닦아요": "tts_ko_82ac13fd646063880f51",
  "정리해요": "tts_ko_6f6deb0dcb047047b3c7",
  "확인해요": "tts_ko_f1ecf5a33dbc524e0588",
  "고쳐요": "tts_ko_ab942f94aa7b866f8843",
  "눌러요": "tts_ko_216cf7335bc370ac192e",
  "바꿔요": "tts_ko_931cdf874c74274ca037",
  "불이야": "tts_ko_6dc65b935eaae774a1b4",
  "화재": "tts_ko_f1fc09aed56afc60f745",
  "비상구": "tts_ko_36f85c800392864e2ea8",
  "구급차": "tts_ko_0295503a6db76c9436af",
  "경찰": "tts_ko_b5fea818bf20c01ae17e",
  "도와주세요": "tts_ko_e2a6ecd481505249380b",
  "다쳤어요": "tts_ko_5f829a045a91972bda2c",
  "피": "tts_ko_28503469a4b93a4ed3d7",
  "대피하세요": "tts_ko_df75ef304fa2eda27e72",
  "응급실": "tts_ko_eff56d3128abc9c36dcf",
  "위": "tts_ko_44b3e9790b3fc05faf47",
  "아래": "tts_ko_ce70382b6d6e7f189baf",
  "앞": "tts_ko_767061b230c1e0da798c",
  "뒤": "tts_ko_59dc4cef60092a42d043",
  "옆": "tts_ko_de9fee63831dc24c0e47",
  "안": "tts_ko_ef105147fd4f251c461b",
  "밖": "tts_ko_e319f0357cb50f19fd03",
  "오른쪽": "tts_ko_ccd36ecafaedc0face87",
  "왼쪽": "tts_ko_b1a53830d10bf5f2dedc",
  "가운데": "tts_ko_40f82e823c4eccbe5242",
  "가게": "tts_ko_1c652cee51e6c76c9467",
  "얼마예요?": "tts_ko_6b1e797e170b9f0eb727",
  "이거 주세요": "tts_ko_d8c8f6c2f27c8709c146",
  "비싸요": "tts_ko_c160f5f86ef156e32a56",
  "싸요": "tts_ko_7867de26a5bc172b66c7",
  "버스": "tts_ko_476a0132093a9d844d09",
  "지하철": "tts_ko_684594de80aefaa97307",
  "택시": "tts_ko_320ea181b585fcb47833",
  "역": "tts_ko_638f20a319e1af5fd274",
  "표": "tts_ko_6e134fb2f478e25ea9b8",
  "어디예요?": "tts_ko_4c96440a758bf31810fb",
  "병원": "tts_ko_c39ae4b9cdfda540fe35",
  "의사": "tts_ko_0a08040b53ff92683a88",
  "약": "tts_ko_807e64f2f285bc348a7a",
  "약국": "tts_ko_9cfdedf83990765f8211",
  "아파요": "tts_ko_61e4cf7264477aebe87c",
  "머리가 아파요": "tts_ko_71dcb43ccbcb21d3850d",
  "은행": "tts_ko_c7d23d0c18435bcf7e32",
  "돈": "tts_ko_54b94545473e11dcde33",
  "카드": "tts_ko_72db3e5effb79a90170c",
  "통장": "tts_ko_8badc250fe33f5ecd1e2",
  "송금": "tts_ko_b2a9600202551821f31e",
  "환전": "tts_ko_44c810c27c36d402312d",
  "김치": "tts_ko_7eacdbb837202b48f8fa",
  "라면": "tts_ko_3bff805eca9774811de1",
  "사과": "tts_ko_87f4fff438f07217927d",
  "배고파요": "tts_ko_e77b25bd154751770f11",
  "맛있어요": "tts_ko_7e85339d4564ecc01adc",
  "국": "tts_ko_9f30de573ff053f99975",
  "고기": "tts_ko_d66cabbf807ec1ca8370",
  "빵": "tts_ko_90acfa9d140f0a6eaf3a",
  "과일": "tts_ko_0fa08651c1ba59271e5f",
  "반찬": "tts_ko_808d72a88e652a4887d3",
  "커피": "tts_ko_a1dbbeae5d7d7fa0d8a8",
  "차": "tts_ko_66ac15e646b07e52161e",
  "술": "tts_ko_799729354ff3ebf53603",
  "매워요": "tts_ko_a274c8c956f00668dbb0",
  "짜요": "tts_ko_d58843fbb7296be9229c",
  "방": "tts_ko_2541247092794bf6b804",
  "침대": "tts_ko_93d5ff06794508fd3732",
  "화장실": "tts_ko_82a7147799cbb37a7bf4",
  "부엌": "tts_ko_82d2f1de71fb54901205",
  "냉장고": "tts_ko_33d8ce0f7edc934b7732",
  "세탁기": "tts_ko_861ae2b4f97fdd06a9ed",
  "에어컨": "tts_ko_301c5a05a9f7f869543d",
  "문": "tts_ko_65036a6a000eeeb2b6a2",
  "창문": "tts_ko_ea02c915f7100de3f3de",
  "열쇠": "tts_ko_f7fa5a535e747e45862a",
  "날씨": "tts_ko_50ad5b3bd7ecd9d9a395",
  "비": "tts_ko_8937b11a548959f6cd9b",
  "눈이 와요": "tts_ko_d95a0a114db198153725",
  "바람": "tts_ko_eeb7ec43730ae1b716f9",
  "더워요": "tts_ko_524434f4590cd3baedb8",
  "추워요": "tts_ko_606700dad4780a730e29",
  "맑아요": "tts_ko_5a3074e802c30d897101",
  "흐려요": "tts_ko_7f47b15f8c7c27464338",
  "우산": "tts_ko_e7b1ae893fec05d3f20e",
  "장마": "tts_ko_c31a42fc6b76d96611db",
  "옷": "tts_ko_a7e5aff3bcb838597702",
  "바지": "tts_ko_1aa41f027b2c763fefe5",
  "신발": "tts_ko_2020a5091ef10c649b39",
  "셔츠": "tts_ko_248f6143071a4fdbf15c",
  "양말": "tts_ko_81a9ad1872a8837146a7",
  "작업복": "tts_ko_3097bb110781f5b05bfd",
  "안전화": "tts_ko_5fdfcfca17f1dca17ac7",
  "마스크": "tts_ko_fd1a507769562f352358",
  "치마": "tts_ko_eb914bcf58d3471c653e",
  "외투": "tts_ko_42eef48ca20947500f13",
  "휴대폰": "tts_ko_a8af409c38704791a69c",
  "전화": "tts_ko_58b7c9d6470982562da0",
  "문자": "tts_ko_dbbd1627c4c633270c9f",
  "전화번호": "tts_ko_874486becf6a58a9958d",
  "와이파이": "tts_ko_dddd348dfb0b7c4357e3",
  "충전기": "tts_ko_70a1e8d527fcbb445a87",
  "인터넷": "tts_ko_ee8455f87f84f2c1cb79",
  "사진": "tts_ko_f24d48126ea87a55ab2a",
  "영상 통화": "tts_ko_4c1300390547d691cbe4",
  "비밀번호": "tts_ko_4bb6aef714237e5481e4",
  "기뻐요": "tts_ko_7d8e6313b414e1b8afd6",
  "슬퍼요": "tts_ko_d09ebd7ea3fa4241bbfb",
  "피곤해요": "tts_ko_beb3fcd2beef2472786a",
  "화나요": "tts_ko_c9fa8ce7bbc3fe4ec414",
  "걱정돼요": "tts_ko_151c9356a4733502e59b",
  "심심해요": "tts_ko_506dd1c3c031bc1b2e34",
  "무서워요": "tts_ko_70a649999e7c47b9ada0",
  "보고 싶어요": "tts_ko_27db90fec0fb3f60d38b",
  "행복해요": "tts_ko_78c180e66f57ba269ddc",
  "외로워요": "tts_ko_7e9d764a68233112c818",
  "기침": "tts_ko_faf6f5db138254397298",
  "감기": "tts_ko_4d2929ad2b4794e10d7c",
  "두통": "tts_ko_59cca4911e2ca9b9f45f",
  "배탈": "tts_ko_4e71311b2df7ad396924",
  "상처": "tts_ko_35c98921a5324e917514",
  "주사": "tts_ko_b2697e8190fa584ddba2",
  "입원": "tts_ko_11aeda864efeb123a204",
  "진통제": "tts_ko_a983cf601aa18f7f1262",
  "소화제": "tts_ko_09c8c8d24600b36209c3",
  "할인": "tts_ko_edaa8ffd080711af46c4",
  "영수증": "tts_ko_f698c9eb5bae8d2ca9c0",
  "교환": "tts_ko_bf013d78537d8a0a6786",
  "환불": "tts_ko_9a305cd6aaf01c7236ca",
  "크기": "tts_ko_70e203b3ef67d52eb926",
  "시장": "tts_ko_234d4bf69e38113fe1f0",
  "편의점": "tts_ko_bb96cad1baa24a1b20d8",
  "봉투": "tts_ko_bb3265e9cf765501fac4",
  "계산해요": "tts_ko_7572b0ca06d06d67dbfb",
  "현금": "tts_ko_788d05f631f04d9e4d99",
  "우체국": "tts_ko_61330b6a5e4aa89f9285",
  "경찰서": "tts_ko_651e9c8ef642d94d53eb",
  "출입국 사무소": "tts_ko_23d6e193809677854953",
  "고용센터": "tts_ko_05eced701030c4828e3c",
  "대사관": "tts_ko_35c9f2805f42e9e8265c",
  "공원": "tts_ko_b980c456302066ed70dc",
  "교회": "tts_ko_6ffb9e71e8cb59540bc2",
  "절": "tts_ko_866ecd68f80bbce737b7",
  "마트": "tts_ko_aad48b540098f138ebef",
  "미용실": "tts_ko_4b07928a5c45eb5f5df1",
  "건설 현장": "tts_ko_0f364b905d56283c40c1",
  "건물": "tts_ko_26f723f36974f2ad0350",
  "벽": "tts_ko_68e3d53a4ab3b96035ea",
  "바닥": "tts_ko_3f98c274f1198591ab7c",
  "천장": "tts_ko_446985c8f9dfc1332172",
  "계단": "tts_ko_33986b7d19dec6d55066",
  "지붕": "tts_ko_2b4466178b0f39e319dc",
  "기둥": "tts_ko_27174a9be96cca6d3b31",
  "창고": "tts_ko_ef31432caae561be5cef",
  "컨테이너": "tts_ko_db9347ae631bea0e9e6b",
  "시멘트": "tts_ko_3451e468eabba80533fa",
  "모래": "tts_ko_42ba59af52b9e03a4e5d",
  "벽돌": "tts_ko_05132acead3ffa98b3fc",
  "철근": "tts_ko_db839cc5e5a9a1dff9b2",
  "목재": "tts_ko_f5fa40a43c3f9abd4617",
  "합판": "tts_ko_49bd23f013c521246726",
  "콘크리트": "tts_ko_a6986220b73b9778713c",
  "타일": "tts_ko_e157c5d8a55b787e7d1f",
  "자갈": "tts_ko_a304371be10dc9563229",
  "못": "tts_ko_bc5e3f55fc57c4d17c9f",
  "삽": "tts_ko_3353060cd2c782b6f361",
  "곡괭이": "tts_ko_ed4e8626e36204856f5e",
  "톱": "tts_ko_2c379d45d1c7dc000cfc",
  "드릴": "tts_ko_6c5c3f372e0504c9564c",
  "줄자": "tts_ko_1e1d3abf9063b2374da4",
  "손수레": "tts_ko_35ea6e9dfbb5e75fa287",
  "크레인": "tts_ko_b78b7e561d5d5a3dff47",
  "굴착기": "tts_ko_c5531b853abcb9a8d25e",
  "비계": "tts_ko_7878874f76bdb0e939b1",
  "레미콘": "tts_ko_adaafeb56f8faf0c7185",
  "파요": "tts_ko_c74162f0e29587f22b55",
  "쌓아요": "tts_ko_3d3a82a38d0c8087efb6",
  "섞어요": "tts_ko_ae1bbd0670630d521e95",
  "부어요": "tts_ko_5199055902ecec71dc41",
  "발라요": "tts_ko_63b486b1b020a3d69254",
  "칠해요": "tts_ko_cf55a5ed2674e9eedf6d",
  "묶어요": "tts_ko_35ad076337431066eaff",
  "재요": "tts_ko_57b5b807ae2b225e08b5",
  "박아요": "tts_ko_36382534faf1195fbbe8",
  "올려요": "tts_ko_784be9dd761c11b31aba",
  "안전벨트": "tts_ko_98ea519fdae5a01aae9a",
  "추락": "tts_ko_7ad1efc07bff48007af2",
  "낙하물": "tts_ko_364146643ab20507d450",
  "위험 구역": "tts_ko_050971d83422ad81f4ff",
  "작업 중지": "tts_ko_1e1df955a0dbe2a59fc9",
  "안전 교육": "tts_ko_500583cce7ab2e745890",
  "감전": "tts_ko_dfd8f74236ecdeb0beb7",
  "보호 안경": "tts_ko_b20e0adec4ddb660bd2c",
  "귀마개": "tts_ko_85683972ded4d6480ecf",
  "소음": "tts_ko_1033029ce54dc1d7c5e6",
  "쌀": "tts_ko_9cf21dd175215a7c19f0",
  "채소": "tts_ko_b396df1e5fc427ec8536",
  "배추": "tts_ko_60a970f7d960a38a6cb8",
  "고추": "tts_ko_cc1acb70b5898e03279b",
  "마늘": "tts_ko_11396fc62ba09bf9994f",
  "양파": "tts_ko_beb3e3d93bedecc003ce",
  "감자": "tts_ko_6e06b76994f485f61a5f",
  "딸기": "tts_ko_5d18faf0e166b29a6288",
  "포도": "tts_ko_36a6b1f67d1b03d2efd3",
  "버섯": "tts_ko_38e00ea620ec992d7c49",
  "밭": "tts_ko_fea2eabfcfb262c5a4b2",
  "논": "tts_ko_ceafd94019e1056e15c4",
  "비닐하우스": "tts_ko_a611845d75bc86609331",
  "씨앗": "tts_ko_2cc413736203072dd41c",
  "심어요": "tts_ko_f345ce1da5ac866d9ea7",
  "물을 줘요": "tts_ko_2156c2584f0d4e7d3f41",
  "수확해요": "tts_ko_66713f6b3caa06b08ef6",
  "비료": "tts_ko_d2ad18544f8ef41251a7",
  "농약": "tts_ko_bcb2c8ad4560a5e3b375",
  "잡초": "tts_ko_2bbc564c63b2f42bf66d",
  "트랙터": "tts_ko_7f681cbf5cb34ae4147d",
  "경운기": "tts_ko_7bff20d76d4a66d83e55",
  "호미": "tts_ko_150dcc0d18cace5f0ef5",
  "낫": "tts_ko_8533b8f92343d74e818f",
  "바구니": "tts_ko_26d16ccebb26441a6952",
  "호스": "tts_ko_55efadc49e2841f893b4",
  "분무기": "tts_ko_4a83c3d8642b0e50493b",
  "장화": "tts_ko_4334a972a38d67383f97",
  "수레": "tts_ko_165e1cdb4eef4d5614c1",
  "전지가위": "tts_ko_35efca373550f0f944fb",
  "소": "tts_ko_21ad0e96945743d3f2df",
  "돼지": "tts_ko_a2f57df76a7ce71375a3",
  "닭": "tts_ko_3d9eccc9ee51116bd22b",
  "오리": "tts_ko_7012c3a93cac9049a508",
  "염소": "tts_ko_5fbf8e82eb2441e005fd",
  "말": "tts_ko_6296ad805795513c3df4",
  "양": "tts_ko_94b36d2eeba2eb9282e3",
  "달걀": "tts_ko_c65741074f54553b1b7e",
  "축사": "tts_ko_6bd2fad933eb0cd7b5d5",
  "사료": "tts_ko_11a31978f486ab80e17d",
  "먹이를 줘요": "tts_ko_97773b0bb474d85f470f",
  "청소해요": "tts_ko_cd6873c63cad14529881",
  "우유를 짜요": "tts_ko_a4fa8121503f9df945bb",
  "소독해요": "tts_ko_59d7e159c88c82745a0c",
  "예방 주사": "tts_ko_a3875e7c3ffeb0a4409f",
  "수의사": "tts_ko_85d629496812fd842f48",
  "환기": "tts_ko_c10fbe8d688555b875fd",
  "온도": "tts_ko_c399c53bd385ea052337",
  "병": "tts_ko_ff8f0748c3deee341413",
  "출하": "tts_ko_d931dd53c0f2cedb3200",
  "배": "tts_ko_ba92041dd8accb0283bc",
  "항구": "tts_ko_012f6a2ebae1f6b304aa",
  "선장": "tts_ko_d03596357aec9f3b8af9",
  "선원": "tts_ko_f7e6dc5b30aed8a22f72",
  "그물": "tts_ko_add50645bee0c2bc3321",
  "낚싯대": "tts_ko_e9fc1f71e676e3a9e6d8",
  "갑판": "tts_ko_43c354431c23a02e4b00",
  "구명조끼": "tts_ko_6a591f5cb8b2f64a20a3",
  "닻": "tts_ko_8db5099047d6a6939f84",
  "생선": "tts_ko_7c4b144814a930272e4e",
  "오징어": "tts_ko_3a4c44d19246b80e30da",
  "새우": "tts_ko_0064fd254c4f95e8f7c0",
  "게": "tts_ko_8fb1d247f4eeb520236b",
  "조개": "tts_ko_1470e5ef8dac9a4c452a",
  "굴": "tts_ko_8330677420c9efd8dfd4",
  "김": "tts_ko_dab6ff887a8eef879900",
  "멸치": "tts_ko_ef8a8d3481a6e8a973e7",
  "고등어": "tts_ko_a7ce3b3fd54e924f94e5",
  "문어": "tts_ko_92af3376533c65a785fd",
  "그물을 던져요": "tts_ko_05508b5cb3e20b06b27b",
  "끌어올려요": "tts_ko_392e885942f0eca1daad",
  "잡아요": "tts_ko_ba043b294da0ee7e6354",
  "분류해요": "tts_ko_80c73379a872d06b4208",
  "손질해요": "tts_ko_5f824614a4f3a24d0adf",
  "얼려요": "tts_ko_d9e7e93374fc74a78ad2",
  "얼음": "tts_ko_b37fa75eba4f74bc628d",
  "냉동 창고": "tts_ko_ac59a5f794169b2083f2",
  "무게": "tts_ko_f37608f334e36b490037",
  "출항": "tts_ko_ed3a67908a5e8fa7e4d3",
  "파도": "tts_ko_427ecf6fd20401ec6f57",
  "태풍": "tts_ko_f85f4cc95d2682b382fd",
  "안개": "tts_ko_299ac6f31464ab851902",
  "폭풍": "tts_ko_111279c330181db6045c",
  "바람이 세요": "tts_ko_2b257553cf57bef57d9b",
  "물살": "tts_ko_c3f00c68932cf1396815",
  "수영": "tts_ko_50971fa9f3940d44b448",
  "구명보트": "tts_ko_74a194d80587da061f25",
  "일기 예보": "tts_ko_6baa718cbfc5a29aa039",
  "귀항": "tts_ko_9925c8a4ca3e22f0f741",
  "양식장": "tts_ko_589475614721a83ac8d5",
  "수조": "tts_ko_f6d61b2ad84635435ded",
  "수온": "tts_ko_fe5c8fc2047dfa7ce2ec",
  "산소": "tts_ko_5ec7d0f6acac32d796bc",
  "치어": "tts_ko_a979b98dcd5dd4ee8632",
  "가공 공장": "tts_ko_108ddfe00840491b9842",
  "작업대": "tts_ko_4bbf3849ee4d438e0209",
  "앞치마": "tts_ko_057c84a14496f3f6fa3d",
  "위생": "tts_ko_3da0dfd52a2f935c6723",
  "포장해요": "tts_ko_14c3ca1a9a652ac24b1b",
  "다음 그림을 보고 맞는 단어나 문장을 고르십시오.": "tts_ko_6cf72bd31ad92f757fa2",
  "다음 중 밑줄 친 부분이 맞는 것은 무엇입니까?": "tts_ko_80c9028c598c5ce4cb0c",
  "다음 글을 읽고 물음에 답하십시오.": "tts_ko_d4515dd21ef789675e1f",
  "다음 단어와 관계있는 것은 무엇입니까?": "tts_ko_11ea1fd6beb78e72eef6",
  "빈칸에 들어갈 가장 알맞은 것을 고르십시오.": "tts_ko_1a20076ddebe5c93d855",
  "다음 설명에 알맞은 어휘를 고르십시오.": "tts_ko_f7de9d2ecff040ab6062",
  "다음 글을 읽고 무엇에 대한 글인지 고르십시오.": "tts_ko_69f0522a31297bed20b2",
  "다음 글을 읽고 내용과 같은 것을 고르십시오.": "tts_ko_10c0372365a3f41a9982",
  "다음 설명을 읽고 알맞은 그림을 고르십시오.": "tts_ko_51e282d249a24d0b67f0",
  "들은 것을 고르십시오.": "tts_ko_06ce3e29af1680647659",
  "다음을 듣고 들은 내용과 관계있는 그림을 고르십시오.": "tts_ko_342d2b5abc6e3489a1ff",
  "사과를 먹어요": "tts_ko_b273425017517c740f98",
  "버스를 타요": "tts_ko_33f1df6cf4b80d2b91cc",
  "다음을 듣고 질문에 알맞은 대답을 고르십시오.": "tts_ko_64b45967f4b2eb6835dc",
  "지금 몇 시예요?": "tts_ko_86b21f7436e92ee06b48",
  "이거 얼마예요?": "tts_ko_792a22323dab81e2ed0a",
  "다음을 듣고 이어지는 말을 고르십시오.": "tts_ko_6be394979677fc843c82",
  "처음 뵙겠습니다.": "tts_ko_a626822f81d73c762648",
  "늦어서 죄송합니다.": "tts_ko_3bc894925fa1c92b658f",
  "이 사과는 삼천 원이에요.": "tts_ko_7d8cb061dde1bc2b8a4b",
  "네 시 삼십 분이에요.": "tts_ko_b4bd409391ffffa63ff0",
  "여기는 어디예요?": "tts_ko_77a1968ba8ccc1fbb214",
  "남: 어디 아파요? 여: 머리가 아파요.": "tts_ko_e9ddc1cd7b817fdff748",
  "여: 어디 가요? 남: 은행에 가요.": "tts_ko_ad3360e971d19e5075fc",
};
